export const ONE_TO_MANY_PRODUCT_INTERNAL_REF = 'shows';
export const ONE_TO_ONE_PRODUCT_INTERNAL_REF = 'calls';
export const ON_DEMAND_PRODUCT_INTERNAL_REF = 'vod';
export const ONE_TO_MANY_PRODUCT_SHORT = 'm';
export const ONE_TO_ONE_PRODUCT_SHORT = 'o';
export const ON_DEMAND_PRODUCT = 'on-demand';
export const ONE_TO_MANY_PRODUCT = 'live';
export const ONE_TO_ONE_PRODUCT = 'calls';
export const CHAT_PRODUCT = 'chat';
export const DEVELOPMENT_PRODUCT = 'development';
export const SUPERADMIN_PRODUCT = 'superadmin';
export const CLIENT_PRODUCT = 'admin';
export const EXISTING_PRODUCTS = [
  ON_DEMAND_PRODUCT,
  ONE_TO_MANY_PRODUCT,
  ONE_TO_ONE_PRODUCT,
  CHAT_PRODUCT,
  DEVELOPMENT_PRODUCT,
  SUPERADMIN_PRODUCT,
  CLIENT_PRODUCT,
];

const now = Date.now();
const scheduledBetaEnd = new Date('2024-10-03T06:30:00Z');

export const DASHBOARD_PRODUCTS = {
  [ONE_TO_MANY_PRODUCT]: {
    id: ONE_TO_MANY_PRODUCT,
    icon: 'showsProduct',
    translationLabel: 'genericLabels.liveProduct',
    translationSubtitle: 'subTitles.live',
  },
  [ONE_TO_ONE_PRODUCT]: {
    id: ONE_TO_ONE_PRODUCT,
    icon: 'callsProduct',
    translationLabel: 'genericLabels.callsProduct',
    translationSubtitle: 'subTitles.calls',
  },
  [ON_DEMAND_PRODUCT]: {
    id: ON_DEMAND_PRODUCT,
    icon: 'onDemandProduct',
    translationLabel: 'genericLabels.onDemandProduct',
    translationSubtitle: 'subTitles.vod',
    isBeta: now < scheduledBetaEnd,
  },
  [CHAT_PRODUCT]: {
    id: CHAT_PRODUCT,
    icon: 'chatProduct',
    translationLabel: 'genericLabels.chatProduct',
    translationSubtitle: 'subTitles.chat',
  },
  [SUPERADMIN_PRODUCT]: {
    id: SUPERADMIN_PRODUCT,
    icon: 'adminProduct',
    translationLabel: 'genericLabels.superadminProduct',
    translationSubtitle: 'subTitles.superAdmin',
  },
  [CLIENT_PRODUCT]: {
    id: CLIENT_PRODUCT,
    icon: 'adminProduct',
    translationLabel: 'genericLabels.adminProduct',
  },
  [DEVELOPMENT_PRODUCT]: {
    id: DEVELOPMENT_PRODUCT,
    icon: 'codeProduct',
    translationLabel: 'genericLabels.developmentProduct',
  },
};

export const GLOBAL_PRODUCTS = [
  DASHBOARD_PRODUCTS[DEVELOPMENT_PRODUCT],
  DASHBOARD_PRODUCTS[CLIENT_PRODUCT],
  DASHBOARD_PRODUCTS[SUPERADMIN_PRODUCT],
];

export const PRODUCT_TO_INTERNAL_REF = {
  [ONE_TO_MANY_PRODUCT]: ONE_TO_MANY_PRODUCT_INTERNAL_REF,
  [ONE_TO_ONE_PRODUCT]: ONE_TO_ONE_PRODUCT_INTERNAL_REF,
  [ON_DEMAND_PRODUCT]: ON_DEMAND_PRODUCT_INTERNAL_REF,
};

export const ORG_PRODUCTS = [
  ONE_TO_MANY_PRODUCT,
  ONE_TO_ONE_PRODUCT,
  ON_DEMAND_PRODUCT,
];
